var render = function render(){var _vm=this,_c=_vm._self._c;return _c('menu-pages',_vm._b({staticClass:"ce-menu-sitemap"},'menu-pages',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }